<div class="custom-chip-list">
  <!-- Show All Chip -->
  <div
    *ngIf="multiple"
    class="chip-option"
    (click)="selectAllChips()"
    (keydown.enter)="selectAllChips()"
    (keydown.space)="selectAllChips()"
    [ngClass]="{ 'disabled-chip': isAllSelected, selected: isAllSelected }"
  >
    {{ 'chip.selector.show_all' | translate }}
  </div>

  <!-- Customizable Chips -->
  <div
    *ngFor="let chip of chips"
    class="chip-option"
    (click)="toggleChip(chip)"
    (keydown.enter)="toggleChip(chip)"
    (keydown.space)="toggleChip(chip)"
    [ngClass]="{
      selected: chip.isSelected,
    }"
  >
    {{ chip.displayName }}
  </div>
</div>
